import { useState } from "react"

import { usePrompt } from "../router"

export const useUnsavedGuard = (
	message = "Changes you made may not be saved.",
) => {
	const [isDirty, setDirty] = useState(false)

	usePrompt(message, isDirty)

	return { setDirty }
}
